<template>
  <div>
    <el-table
      :data="tableData"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
      border
      default-expand-all
      row-key="id"
      style="width: 800px; margin-bottom: 20px"
    >
      <el-table-column label="厂站名称" prop="label" width="180">
      </el-table-column>
      <el-table-column label="成员数" prop="name" width="180">
      </el-table-column>
      <el-table-column label="操作" prop="address">
        <template slot-scope="{ row }">
          <Button type="text" @click="show(row, '1')">添加子厂站</Button>
          <Button type="text" @click="show(row, '2')">编辑厂站</Button>
        </template>
      </el-table-column>
    </el-table>
    <Drawer
      v-model="showDrawer"
      :closable="false"
      :title="
        showIndex == '1'
          ? '添加子厂站'
          : showIndex == '2'
          ? '编辑厂站'
          : '设置厂站主管'
      "
      width="500px"
    >
      <el-form
        ref="formAddDepartment"
        :model="formAddDepartment"
        :rules="rulesAddDepartment"
        class="demo-ruleForm"
        status-icon
      >
        <el-form-item label="厂站名称" prop="departmentName">
          <el-input
            v-model="formAddDepartment.departmentName"
            :disabled="row.id=='0' && showIndex=='2'"
            autocomplete="off"
            placeholder="请输入厂站名称"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="上级厂站"
          prop=""
          style="margin-top: 40px; margin-bottom: 40px"
        >
          <el-input
            v-model="sbvalue"
            :disabled="row.id=='0'"
            placeholder="请选择上级厂站"
            @blur="blur"
            @focus="clicklabel"
          >
          </el-input>
        </el-form-item>
        <el-form-item

          v-if="showIndex=='2'"
          label="厂站主管"
          style="margin-top: 40px; margin-bottom: 40px"
        >
          <el-input v-model="row.date" placeholder="请选择厂站主管"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button
            class="submit"
            type="primary"
            @click="submit('formAddDepartment')"
          >保存
          </el-button
          >
        </el-form-item>
        <el-button
          v-if="showIndex=='2' && row.id!='0'"
          class="danger"
          type="danger"
          @click="danger('formAddDepartment')"
        >删除厂站
        </el-button
        >
      </el-form>
      <el-dialog
        :modal="false"
        :visible.sync="dialogVisible"
        title=""
        width="500px"
      >
        <div>
          <div class="selectbox">
            <div class="selectleft">
              <p>选择：</p>
              <el-tree
                :data="tableData"
                :default-expand-all="true"
                :props="defaultProps"
                accordion
                @node-click="handleNodeClick"
              >
              </el-tree>
            </div>
            <div class="selectright">
              <p>已选：</p>
              <p>{{ rowFather.label }}</p>
            </div>
          </div>
          <div class="btn">
            <el-button class="submit" type="primary" @click="selectDepartment()"
            >确定
            </el-button
            >
          </div>

        </div>
      </el-dialog>
    </Drawer>
  </div>

</template>
<script>
import {deptDelete, deptList, deptPost, deptPut} from '@/api/organization'

export default {
  data() {
    const validateDepartmentName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error("请输入子厂站名称"));
      } else {
        callback();
      }
    };
    return {
      showDrawer: false,
      sbvalue: "",
      showIndex: "",
      dialogVisible: false,
      titleName: '牛牛有限公司',
      rows: {},
      row: {},
      personnelData: [
        {
          name: '徐勤康',
          phone: '15057154262'

        }
      ],
      tableData: [],
      formAddDepartment: {
        departmentName: "",
      },
      rulesAddDepartment: {
        departmentName: [
          {validator: validateDepartmentName, trigger: "blur"},
        ],
      },
      defaultProps: {
        children: "children",
        label: "label",
      },
      rowFather: {}
    };
  },
  mounted() {
    this.init()
  },
  methods: {
    init() {
      deptList({companyId: ''}).then((res) => {
        console.log(res)
        this.tableData = res.data.data
      })
    },
    show(row, index) {
      this.showIndex = index;
      this.showDrawer = true;
      this.row = row;
      this.sbvalue = '无';
      if (this.showIndex == '2') {
        this.forboss(this.tableData)
        this.formAddDepartment.departmentName = this.row.label;
      }
    },
    danger(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          console.log(this.row)
          if (this.row.children.length) {
            this.$confirmss('检测到该厂站下有子厂站，是否同时删除子厂站？', '提示', {
              distinguishCancelAndClose: true,
              confirmButtonText: '保留子厂站',
              cancelButtonText: '同时删除'
            })
              .then(() => {
                deptDelete({
                  deptId: this.row.id,
                  removeChildren: '0'
                }).then((res) => {
                  if (res.data.success) {
                    this.showDrawer = false;
                    this.$alert("厂站删除成功", "提示", {
                      confirmButtonText: "确定",
                      callback: (action) => {
                        this.init()
                        this.formAddDepartment.departmentName = ''
                      },
                    });
                  }
                })
              })
              .catch(action => {
                if (action === 'cancel') {
                  deptDelete({
                    deptId: this.row.id,
                    removeChildren: '1'
                  }).then((res) => {
                    if (res.data.success) {
                      this.showDrawer = false;
                      this.$alert("厂站删除成功", "提示", {
                        confirmButtonText: "确定",
                        callback: (action) => {
                          this.init()
                          this.formAddDepartment.departmentName = ''
                        },
                      });
                    }
                  })
                }
              });
          } else {
            this.$Modal.confirm({
              title: '提示',
              content: '<p>是否确认删除该厂站</p>',
              onOk: () => {
                deptDelete({
                  deptId: this.row.id,
                  removeChildren: '0'
                }).then((res) => {
                  if (res.data.success) {
                    this.showDrawer = false;
                    this.$alert("厂站删除成功", "提示", {
                      confirmButtonText: "确定",
                      callback: (action) => {
                        this.init()
                        this.formAddDepartment.departmentName = ''
                      },
                    });
                  }
                })
              },
              onCancel: () => {

              }
            });
          }
        }
      })
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.showIndex == '1') {
            deptPost({
              // orgId:localStorage.getItem('peopleOrgid'),
              deptName: this.formAddDepartment.departmentName,
              parentId: this.row.id
            }).then((res) => {
              console.log(res)
              if (res.data.success) {
                this.showDrawer = false;
                this.$alert("厂站新建成功", "提示", {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    this.init()
                    this.formAddDepartment.departmentName = ''
                  },
                });
              }
            })
          } else if (this.showIndex == '2') {
            deptPut({
              // orgId:localStorage.getItem('peopleOrgid'),
              deptName: this.formAddDepartment.departmentName,
              parentId: this.rowFather.id,
              deptId: this.row.id
            }).then((res) => {
              console.log(res)
              if (res.data.success) {
                this.showDrawer = false;
                this.$alert(this.showIndex == '2' ? '编辑成功' : "添加成功", "提示", {
                  confirmButtonText: "确定",
                  callback: (action) => {
                    this.init()
                    this.formAddDepartment.departmentName = ''
                  },
                });
              }
            })
          }

        }
      });
    },
    handleNodeClick(data) {
      this.rowFather = data;
    },
    blur() {
      this.sbvalue = this.rowFather.label
    },
    clicklabel() {
      this.dialogVisible = true;
    },
    forboss(e) {
      let a = this.row.id
      e.forEach(s => {
        if (s.children) {
          s.children.forEach(b => {
            if (b.id == a) {
              this.rowFather = s
              this.sbvalue = this.rowFather.label;
            } else {
              this.forboss(s.children)
            }
          })
        }
      })
    },
    selectDepartment() {
      this.sbvalue = this.rowFather.label;
      this.dialogVisible = false;
    },
    personnelTreeClick() {

    }
  },
};
</script>
<style lang="less">
.danger {
  position: fixed;
  bottom: 20px;
  width: 468px;
}

.submit {
  float: right;
}

.selectbox {
  display: flex;
  flex-direction: row;

  .selectleft {
    width: 230px;
  }

  .selectright {
    width: 230px;
  }
}

.btn {
  height: 40px;
}

.content {
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  .left {
    padding: 10px;
    width: 300px;
  }

  .right {
    .title {
      .titlep {
        color: #171a1d;
        font-weight: 600;
        font-size: 17px;
      }
    }

    .btns {
      .btn {
        margin-right: 10px;
      }
    }
  }
}
</style>
